module.exports = __webpack_public_path__ + "img/xtnl-009.6fce0f55.jpg";